import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextareaAutosize,
  TextField,
  Autocomplete,
  Typography,
  Divider,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import NewsvalidationSchema from "./Validations/NewsValidations";
import api from "../axiosInstance";
import { toast } from "react-toastify";
import CouponValidationSchema from "./Validations/CouponValidation";
import { red } from "@mui/material/colors";
import {
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
  BUTTON_STYLES,
  FORM_STYLES,
} from "../styles/componentStyles";
import DownloadIcon from "@mui/icons-material/Download";

// Coupon Code generation with randow
function generateRandomCode(length = 5) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
// Coupon Function start form here
function CouponModal({ open, onClose, newsEdit, onSuccess }) {
  const [universityList, setUniversityList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [selectedUniversityId, setSelectedUniversityId] = useState("");
  const [courseList, setCourseList] = useState([]);
  console.log(newsEdit);

  const isEditing = !!(newsEdit && newsEdit.id);

  // Admin users async options state
  const [adminUsers, setAdminUsers] = useState([]);
  const [adminUsersPage, setAdminUsersPage] = useState(0);
  const [adminUsersTotalPages, setAdminUsersTotalPages] = useState(0);
  const [adminUsersLoading, setAdminUsersLoading] = useState(false);
  const [adminUsersQuery, setAdminUsersQuery] = useState("");
  const [selectedAdminUser, setSelectedAdminUser] = useState(null);
  const [categories, setCategories] = useState([]);
  const listboxRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
  const [createdCoupons, setCreatedCoupons] = useState([]);

  // Render label: FirstName - Phone
  const renderAdminUserLabel = (u) => {
    if (!u) return "";
    const name = [u.firstName].filter(Boolean).join(" ").trim();
    const phone = u.phoneNumber;
    return [name || undefined, phone].filter(Boolean).join(" - ");
  };

  // Validation with formik form. Add and update forms
  const formik = useFormik({
    initialValues: {
      couponCount: "1",
      precode: newsEdit?.code || "",
      description: newsEdit?.description || "",
      discountType: newsEdit?.discountType || "",
      discountValue: newsEdit?.discountValue || "",
      usageLimit: newsEdit?.usageLimit || "",
      usageCount: newsEdit?.usageCount ?? 0,
      perUserUsageLimit: newsEdit?.perUserUsageLimit || "",
      active: newsEdit?.active ?? true,
      maxLimitDiscount: newsEdit?.maxLimitDiscount || "",
      minSpend: newsEdit?.minSpend || "",
      isUserSpecific: newsEdit?.isUserSpecific ?? false,
      targetUserId: newsEdit?.targetUserId || "",
      couponReference: newsEdit?.couponReference || "",
      viewable: newsEdit?.viewable ?? false,
      sharable: newsEdit?.sharable ?? false,
      categoryId: newsEdit?.categoryId || "",
      isCollegeSpecific: newsEdit?.isCollegeSpecific ?? false,
      targetCollegeId: newsEdit?.targetCollegeId ?? "",
      targetCollegeName: newsEdit?.targetCollegeName || "",
      isUniversitySpecific: newsEdit?.isUniversitySpecific ?? false,
      targetUniversityId: newsEdit?.targetUniversityId ?? "",
      targetUniversityName: newsEdit?.targetUniversityName || "",
      isCourseSpecific: newsEdit?.isCourseSpecific ?? false,
      targetCourseId: newsEdit?.targetCourseId ?? "",
      targetCourseName: newsEdit?.targetCourseName || "",
      remainingBalance: newsEdit?.remainingBalance ?? 0,
      supportsPartialUsage: newsEdit?.supportsPartialUsage ?? false,
    },

    validationSchema: CouponValidationSchema,
    enableReinitialize: true, // This line of code show the value in form field in update time
    onSubmit: async (values, { resetForm }) => {
      setIsProcessing(true);
      console.log(values);

      try {
        setCreatedCoupons([]);
        let successCount = 0;
        let errorCount = 0;
        // Update api call  block code.
        if (isEditing) {
          const { couponCount, precode, ...couponPayload } = values;

          const count = parseInt(couponCount, 10);
          const prefix = precode.toUpperCase();
          const couponSendData = {
            ...couponPayload,
            code: prefix,
          };
          await api.put(`/api/v1/coupons/${newsEdit.id}`, couponSendData, {
            ...couponSendData,
            // // normalize boolean strings back to booleans for API if needed
            // active: values.active === "true",
            // viewable: values.viewable === "true",
            // sharable: values.sharable === "true",
            // isUserSpecific: values.isUserSpecific === "true",
            // isCollegeSpecific: values.isCollegeSpecific === "true",
            // supportsPartialUsage: values.supportsPartialUsage === "true",
          });
        } else {
          // Coupons Adding post api calls block of code
          const { couponCount, precode, ...couponPayload } = values;

          const count = parseInt(couponCount, 10);
          const prefix = precode.toUpperCase();
          // checking the coupon count is is 1 or more then 1
          if (count === 1) {
            // Just send prefix as coupon code
            const couponSendData = {
              ...couponPayload,
              code: prefix,
            };
            const delay = (ms) =>
              new Promise((resolve) => setTimeout(resolve, ms));
            try {
              console.log("payload :", couponSendData);
              await api.post("/api/v1/coupons", couponSendData);
              successCount++;
              setCreatedCoupons((prev) => [
                ...prev,
                { code: prefix, description: couponPayload.description || "" },
              ]);
            } catch (error) {
              errorCount++;
              console.error(`Failed to post coupon ${prefix}:`, error);
            }
            await delay(100);
          } else if (count > 1) {
            const generatedCodes = new Set();
            const delay = (ms) =>
              new Promise((resolve) => setTimeout(resolve, ms));
            // Keep generating until we have the required number of unique codes
            while (generatedCodes.size < count) {
              const fullCouponCode = prefix + generateRandomCode();

              if (!generatedCodes.has(fullCouponCode)) {
                generatedCodes.add(fullCouponCode);

                const couponSendData = {
                  ...couponPayload,
                  code: fullCouponCode,
                };

                try {
                  await api.post("/api/v1/coupons", couponSendData);
                  successCount++;
                  setCreatedCoupons((prev) => [
                    ...prev,
                    {
                      code: fullCouponCode,
                      description: couponPayload.description || "",
                    },
                  ]);
                } catch (error) {
                  errorCount++;
                  console.error(
                    `Failed to post coupon ${fullCouponCode}:`,
                    error,
                  );
                }
                await delay(100);
              }
            }

            console.log(
              " Generated Unique Coupon Codes:",
              Array.from(generatedCodes),
            );
            console.log(`Success: ${successCount}, Failed: ${errorCount}`);
          }

          // await api.post("/api/v1/coupons", values);
        }
        toast.success(
          isEditing
            ? "Coupon updated successfully!"
            : `${successCount} Coupon Added successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );

        onSuccess();
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setIsProcessing(false);
        if (!isEditing) {
          setOpenDownloadDialog(true);
        }
      }
    },
  });

  // Universities get api call's
  useEffect(() => {
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch((err) => console.error(err));
  }, []);
  // Courses get api call's
  useEffect(() => {
    api
      .get("/getCourses", { params: { active: true } })
      .then((res) => setCourseList(res.data.data))
      .catch((err) => console.error(err));
  }, []);
  useEffect(() => {
    const defaultCategory = "COUPONS_CATEGORIES";
    api
      .get(`/api/v1/code-values/${defaultCategory}`)
      .then((res) => setCategories(res.data.data))
      .catch((err) => console.error(err));
  }, []);

  // Admin users: fetch function (paged, optional phone search)
  const fetchAdminUsers = async ({ page = 0, query = "" }) => {
    setAdminUsersLoading(true);
    try {
      const resp = await api.get("/api/v1/admin/users", {
        params: {
          page,
          size: 10,
          phone: query || undefined,
        },
      });
      const content = resp.data?.content ?? [];
      const totalPages = resp.data?.totalPages ?? 0;
      setAdminUsers((prev) => (page === 0 ? content : [...prev, ...content]));
      setAdminUsersTotalPages(totalPages);
      setAdminUsersPage(page);
    } catch (e) {
      console.error(e);
    } finally {
      setAdminUsersLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchAdminUsers({ page: 0, query: "" });
  }, []);

  // Debounced query search by phone number
  useEffect(() => {
    const t = setTimeout(() => {
      // reset list and fetch first page with query
      fetchAdminUsers({ page: 0, query: adminUsersQuery.trim() });
    }, 400);
    return () => clearTimeout(t);
  }, [adminUsersQuery]);

  // Keep selectedAdminUser in sync if targetUserId already set
  useEffect(() => {
    if (!formik.values.targetUserId) {
      setSelectedAdminUser(null);
      return;
    }
    const found = adminUsers.find((u) => u.id === formik.values.targetUserId);
    if (found) setSelectedAdminUser(found);
  }, [formik.values.targetUserId, adminUsers]);

  // Colleges when university changes
  useEffect(() => {
    if (selectedUniversityId) {
      const fetchColleges = async () => {
        try {
          const response = await api.get(
            `/getColleges/${selectedUniversityId}`,
          );
          setCollegeList(response.data.data);
        } catch (error) {
          console.error("Failed to load colleges", error);
        }
      };
      fetchColleges();
    } else {
      setCollegeList([]);
    }
  }, [selectedUniversityId]);

  // Listbox onScroll: load next page when near bottom
  const handleUsersListboxScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (!listboxNode) return;
    const nearBottom =
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 24;
    const hasNext = adminUsersPage + 1 < adminUsersTotalPages;
    if (nearBottom && hasNext && !adminUsersLoading) {
      fetchAdminUsers({
        page: adminUsersPage + 1,
        query: adminUsersQuery.trim(),
      });
    }
  };
  // CSV DOWNLOAD
  const downloadCsv = () => {
    if (createdCoupons.length === 0) return;

    const today = new Date();
    today.setDate(today.getDate() - 1);
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    const csvRows = ["Coupon Code,Description,Created Date"];

    createdCoupons.forEach((coupon) => {
      csvRows.push(
        `${coupon.code},${coupon.description || ""},${formattedDate}`,
      );
    });

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "created_coupons.csv";
    link.click();
  };

  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {isEditing ? "Edit Coupon" : "Add Coupon"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              label="Coupon Code"
              name="precode"
              value={formik.values.precode}
              onChange={(e) => {
                const val = e.target.value.toUpperCase();
                formik.setFieldValue("precode", val);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.precode && Boolean(formik.errors.precode)}
              helperText={formik.touched.precode && formik.errors.precode}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <TextField
              label="How Many Coupons to Add?"
              name="couponCount"
              type="number"
              value={formik.values.couponCount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.couponCount && Boolean(formik.errors.couponCount)
              }
              helperText={
                formik.touched.couponCount && formik.errors.couponCount
              }
              {...TEXT_FIELD_STYLES.standard}
              required
              inputProps={{ min: 1 }}
            />
            <TextField
              multiline
              minRows={2}
              label="Description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="discount-type-label">Category Code</InputLabel>
              <Select
                labelId="discount-type-label"
                id="discount-type"
                label="Category Code"
                name="categoryId"
                value={formik.values.categoryId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.categoryId && Boolean(formik.errors.categoryId)
                }
              >
                {categories.map((categorie) => {
                  return (
                    <MenuItem value={categorie.id} key={categorie.id}>
                      {categorie.code}
                    </MenuItem>
                  );
                })}
              </Select>
              {formik.touched.categoryId && formik.errors.categoryId && (
                <FormHelperText sx={{ color: "#d9322f" }}>
                  {formik.errors.categoryId}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="discount-type-label">Discount Type</InputLabel>
              <Select
                labelId="discount-type-label"
                id="discount-type"
                label="Discount Type "
                name="discountType"
                value={formik.values.discountType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.discountType &&
                  Boolean(formik.errors.discountType)
                }
              >
                <MenuItem value="percentage">Percentage</MenuItem>
                <MenuItem value="cash">Cash</MenuItem>
              </Select>
              {formik.touched.discountType && formik.errors.discountType && (
                <FormHelperText sx={{ color: "#d9322f" }}>
                  {formik.errors.discountType}
                </FormHelperText>
              )}
            </FormControl>

            <TextField
              label="Discount Value"
              fullWidth
              margin="normal"
              type="number"
              inputProps={{ min: 0 }}
              name="discountValue"
              value={formik.values.discountValue}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.discountValue &&
                Boolean(formik.errors.discountValue)
              }
              helperText={
                formik.touched.discountValue && formik.errors.discountValue
              }
            />

            <TextField
              label="Usage Limit"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              margin="normal"
              name="usageLimit"
              value={formik.values.usageLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.usageLimit && Boolean(formik.errors.usageLimit)
              }
              helperText={formik.touched.usageLimit && formik.errors.usageLimit}
            />

            <TextField
              label="Usage Count"
              sx={{ display: "none" }}
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              margin="normal"
              name="usageCount"
              value={formik.values.usageCount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.usageCount && Boolean(formik.errors.usageCount)
              }
              helperText={formik.touched.usageCount && formik.errors.usageCount}
            />

            <TextField
              label="Per User Usage Limit"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              margin="normal"
              name="perUserUsageLimit"
              value={formik.values.perUserUsageLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.perUserUsageLimit &&
                Boolean(formik.errors.perUserUsageLimit)
              }
              helperText={
                formik.touched.perUserUsageLimit &&
                formik.errors.perUserUsageLimit
              }
            />

            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                label="Active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.active && Boolean(formik.errors.active)}
              >
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Max Limit Discount"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              margin="normal"
              name="maxLimitDiscount"
              value={formik.values.maxLimitDiscount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.maxLimitDiscount &&
                Boolean(formik.errors.maxLimitDiscount)
              }
              helperText={
                formik.touched.maxLimitDiscount &&
                formik.errors.maxLimitDiscount
              }
            />

            <TextField
              label="Min Spend"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              margin="normal"
              name="minSpend"
              value={formik.values.minSpend}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.minSpend && Boolean(formik.errors.minSpend)}
              helperText={formik.touched.minSpend && formik.errors.minSpend}
            />

            <FormControl
              component="fieldset"
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ marginTop: 2 }}
            >
              <FormLabel component="legend">Is UserSpecific</FormLabel>
              <RadioGroup
                row
                name="isUserSpecific"
                value={formik.values.isUserSpecific}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {formik.touched.isUserSpecific &&
                formik.errors.isUserSpecific && (
                  <FormHelperText>
                    {formik.errors.isUserSpecific}
                  </FormHelperText>
                )}
            </FormControl>

            {formik.values.isUserSpecific === "true" && (
              <FormControl
                fullWidth
                sx={{ marginBottom: "8px", marginTop: "16px" }}
              >
                <InputLabel shrink>Target User</InputLabel>
                <Autocomplete
                  loading={adminUsersLoading}
                  options={adminUsers}
                  value={selectedAdminUser}
                  getOptionLabel={(option) => renderAdminUserLabel(option)}
                  onChange={(event, newValue) => {
                    setSelectedAdminUser(newValue || null);
                    formik.setFieldValue("targetUserId", newValue?.id || "");
                    if (formik.values.isUserSpecific === "true") {
                      formik.setFieldValue(
                        "couponReference",
                        newValue?.phoneNumber || "",
                      );
                    }
                  }}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      setAdminUsersQuery(newInputValue || "");
                    }
                  }}
                  ListboxProps={{ onScroll: handleUsersListboxScroll }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search by phone number"
                      margin="normal"
                      placeholder="Type phone number to search"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {renderAdminUserLabel(option)}
                    </li>
                  )}
                  filterOptions={(x) => x} // disable client filtering; we use server-side results
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  noOptionsText={adminUsersLoading ? "Loading..." : "No users"}
                />
                {formik.touched.targetUserId && formik.errors.targetUserId && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.targetUserId}
                  </FormHelperText>
                )}
              </FormControl>
            )}

            <TextField
              label="Coupon Reference"
              fullWidth
              margin="normal"
              name="couponReference"
              value={formik.values.couponReference}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={
                formik.values.isUserSpecific === "true" && !!selectedAdminUser
              }
              error={
                formik.touched.couponReference &&
                Boolean(formik.errors.couponReference)
              }
              helperText={
                formik.touched.couponReference && formik.errors.couponReference
              }
            />

            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="viewable-label">Viewable</InputLabel>
              <Select
                labelId="viewable-label"
                id="viewable"
                label="Viewable"
                name="viewable"
                value={formik.values.viewable}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.viewable && Boolean(formik.errors.viewable)
                }
              >
                <MenuItem value="true">True</MenuItem>
                <MenuItem value="false">False</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="sharable-label">Sharable</InputLabel>
              <Select
                labelId="sharable-label"
                id="sharable"
                label="Sharable"
                name="sharable"
                value={formik.values.sharable}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.sharable && Boolean(formik.errors.sharable)
                }
              >
                <MenuItem value="true">True</MenuItem>
                <MenuItem value="false">False</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              component="fieldset"
              error={
                formik.touched.isUniversitySpecific &&
                Boolean(formik.errors.isUniversitySpecific)
              }
              sx={{ marginTop: 2 }}
            >
              <FormLabel component="legend">Is University Specific</FormLabel>

              <RadioGroup
                row
                name="isUniversitySpecific"
                value={formik.values.isUniversitySpecific}
                onChange={(e) => {
                  const value = e.target.value === "true";
                  formik.setFieldValue("isUniversitySpecific", value);

                  //  Clear when "No"
                  if (!value) {
                    formik.setFieldValue("targetUniversityId", "");
                    formik.setFieldValue("targetUniversityName", "");
                  }
                }}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>

              {formik.touched.isUniversitySpecific &&
                formik.errors.isUniversitySpecific && (
                  <FormHelperText>
                    {formik.errors.isUniversitySpecific}
                  </FormHelperText>
                )}
            </FormControl>

            {/*  Show dropdown only if Yes */}
            {formik.values.isUniversitySpecific === true && (
              <FormControl
                fullWidth
                sx={{ marginBottom: "8px", marginTop: "16px" }}
                error={
                  formik.touched.targetUniversityId &&
                  Boolean(formik.errors.targetUniversityId)
                }
              >
                <InputLabel id="university-label">University</InputLabel>

                <Select
                  labelId="university-label"
                  id="university"
                  label="University"
                  name="targetUniversityId"
                  value={formik.values.targetUniversityId}
                  onChange={(e) => {
                    const selectedId = e.target.value;

                    //  set BOTH fields properly
                    formik.setFieldValue("targetUniversityId", selectedId);

                    const selectedUniversity = universityList.find(
                      (u) => String(u.id) === String(selectedId),
                    );
                    formik.setFieldValue("targetCollegeName", "");
                    formik.setFieldValue(
                      "targetUniversityName",
                      selectedUniversity ? selectedUniversity.name : "",
                    );

                    setSelectedUniversityId(selectedId);
                  }}
                  onBlur={formik.handleBlur}
                >
                  {universityList.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.name}
                    </MenuItem>
                  ))}
                </Select>

                <FormHelperText>
                  {formik.touched.targetUniversityId &&
                    formik.errors.targetUniversityId}
                </FormHelperText>
              </FormControl>
            )}

            {/*  Show name only if selected */}
            {formik.values.isUniversitySpecific === true &&
              formik.values.targetUniversityId && (
                <TextField
                  label="Target University Name"
                  fullWidth
                  margin="normal"
                  disabled
                  name="targetUniversityName"
                  value={formik.values.targetUniversityName}
                />
              )}
            <Divider />
            <FormControl
              component="fieldset"
              error={
                formik.touched.isCollegeSpecific &&
                Boolean(formik.errors.isCollegeSpecific)
              }
              sx={{ marginTop: 2 }}
            >
              <FormLabel component="legend">Is College Specific</FormLabel>

              <RadioGroup
                row
                name="isCollegeSpecific"
                value={formik.values.isCollegeSpecific}
                onChange={(e) => {
                  const value = e.target.value === "true";
                  formik.setFieldValue("isCollegeSpecific", value);

                  //  Clear all when "No"
                  if (!value) {
                    formik.setFieldValue("targetCollegeId", "");
                    formik.setFieldValue("targetCollegeName", "");
                  }
                }}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>

              {formik.touched.isCollegeSpecific &&
                formik.errors.isCollegeSpecific && (
                  <FormHelperText>
                    {formik.errors.isCollegeSpecific}
                  </FormHelperText>
                )}
            </FormControl>

            {/*  Show University only if Yes */}
            {formik.values.isCollegeSpecific === true && (
              <FormControl
                fullWidth
                sx={{ marginBottom: "8px", marginTop: "16px" }}
                error={
                  formik.touched.targetUniversityId &&
                  Boolean(formik.errors.targetUniversityId)
                }
              >
                <InputLabel id="university-label">University</InputLabel>
                <Select
                  labelId="university-label"
                  id="university"
                  label="University"
                  name="targetUniversityId"
                  value={formik.values.targetUniversityId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedUniversity = universityList.find(
                      (u) => String(u.id) === String(selectedId),
                    );

                    //  Set university & reset college
                    formik.setFieldValue("targetUniversityId", selectedId);
                    formik.setFieldValue("targetCollegeId", "");
                    formik.setFieldValue("targetCollegeName", "");
                    formik.setFieldValue(
                      "targetUniversityName",
                      selectedUniversity ? selectedUniversity.name : "",
                    );
                    setSelectedUniversityId(selectedId);
                    // for API call if needed
                  }}
                  onBlur={formik.handleBlur}
                >
                  {universityList.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.name}
                    </MenuItem>
                  ))}
                </Select>

                <FormHelperText>
                  {formik.touched.targetUniversityId &&
                    formik.errors.targetUniversityId}
                </FormHelperText>
              </FormControl>
            )}

            {/* Show College only if Yes AND university selected */}
            {formik.values.isCollegeSpecific === true &&
              formik.values.targetUniversityId &&
              collegeList.length > 0 && (
                <FormControl
                  fullWidth
                  sx={{ mt: 2 }}
                  error={
                    formik.touched.targetCollegeId &&
                    Boolean(formik.errors.targetCollegeId)
                  }
                >
                  <InputLabel id="college-label">Target College</InputLabel>
                  <Select
                    labelId="college-label"
                    name="targetCollegeId"
                    value={formik.values.targetCollegeId}
                    label="Target College"
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      formik.setFieldValue("targetCollegeId", selectedId);

                      const selectedCollege = collegeList.find(
                        (college) => college.id === selectedId,
                      );

                      formik.setFieldValue(
                        "targetCollegeName",
                        selectedCollege ? selectedCollege.name : "",
                      );
                    }}
                  >
                    {collegeList.map((college) => (
                      <MenuItem key={college.id} value={college.id}>
                        {college.name}
                      </MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>
                    {formik.touched.targetCollegeId &&
                      formik.errors.targetCollegeId}
                  </FormHelperText>
                </FormControl>
              )}

            {/* Show College Name only if selected */}
            {formik.values.isCollegeSpecific === true &&
              formik.values.targetCollegeId && (
                <TextField
                  label="Target College Name"
                  fullWidth
                  margin="normal"
                  disabled
                  name="targetCollegeName"
                  value={formik.values.targetCollegeName}
                />
              )}
            <Divider />

            <FormControl
              component="fieldset"
              error={
                formik.touched.isCourseSpecific &&
                Boolean(formik.errors.isCourseSpecific)
              }
              sx={{ marginTop: 2 }}
            >
              <FormLabel component="legend">Is CourseSpecific</FormLabel>
              <RadioGroup
                row
                name="isCourseSpecific"
                value={formik.values.isCourseSpecific}
                onChange={(e) => {
                  const value = e.target.value === "true";
                  formik.setFieldValue("isCourseSpecific", value);

                  if (!value) {
                    formik.setFieldValue("targetCourseId", "");
                    formik.setFieldValue("targetCourseName", "");
                  }
                }}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {formik.touched.isCourseSpecific &&
                formik.errors.isCourseSpecific && (
                  <FormHelperText>
                    {formik.errors.isCourseSpecific}
                  </FormHelperText>
                )}
            </FormControl>
            {/*  Show University only if Yes */}
            {formik.values.isCourseSpecific === true && (
              <FormControl
                fullWidth
                sx={{ marginBottom: "8px", marginTop: "16px" }}
                error={
                  formik.touched.targetUniversityId &&
                  Boolean(formik.errors.targetUniversityId)
                }
              >
                <InputLabel id="university-label">University</InputLabel>
                <Select
                  labelId="university-label"
                  id="university"
                  label="University"
                  name="targetUniversityId"
                  value={formik.values.targetUniversityId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedUniversity = universityList.find(
                      (u) => String(u.id) === String(selectedId),
                    );
                    //  Set university & reset college
                    formik.setFieldValue("targetUniversityId", selectedId);
                    formik.setFieldValue("targetCourseId", "");
                    formik.setFieldValue("targetCourseName", "");
                    formik.setFieldValue(
                      "targetUniversityName",
                      selectedUniversity ? selectedUniversity.name : "",
                    );

                    setSelectedUniversityId(selectedId); // for API call if needed
                  }}
                  onBlur={formik.handleBlur}
                >
                  {universityList.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.name}
                    </MenuItem>
                  ))}
                </Select>

                <FormHelperText>
                  {formik.touched.targetUniversityId &&
                    formik.errors.targetUniversityId}
                </FormHelperText>
              </FormControl>
            )}

            {/* Show Course only if Yes AND university selected */}
            {formik.values.isCourseSpecific === true &&
              formik.values.targetUniversityId &&
              courseList.length > 0 && (
                <FormControl
                  fullWidth
                  sx={{ mt: 2 }}
                  error={
                    formik.touched.targetCourseId &&
                    Boolean(formik.errors.targetCourseId)
                  }
                >
                  <InputLabel id="course-label">Target Course</InputLabel>
                  <Select
                    labelId="course-label"
                    name="targetCourseId"
                    value={formik.values.targetCourseId}
                    label="Target Course"
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      formik.setFieldValue("targetCourseId", selectedId);
                      formik.setFieldValue("targetCourseName", ""); // reset course name if course selected

                      const selectedCourse = courseList.find(
                        (course) => course.id === selectedId,
                      );

                      formik.setFieldValue(
                        "targetCourseName",
                        selectedCourse ? selectedCourse.courseName : "",
                      );
                    }}
                  >
                    {courseList
                      .filter(
                        (course) =>
                          course.universityId ===
                          formik.values.targetUniversityId,
                      )
                      .map((course) => (
                        <MenuItem key={course.id} value={course.id}>
                          {course.id} - {course.courseName}
                        </MenuItem>
                      ))}
                  </Select>

                  <FormHelperText>
                    {formik.touched.targetCourseId &&
                      formik.errors.targetCourseId}
                  </FormHelperText>
                </FormControl>
              )}

            {/* Show Course Name only if selected */}
            {formik.values.isCourseSpecific === true &&
              formik.values.targetCourseId && (
                <TextField
                  label="Target Course Name"
                  fullWidth
                  margin="normal"
                  disabled
                  name="targetCourseName"
                  value={formik.values.targetCourseName}
                />
              )}
            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="partial-usage-label">
                Supports PartialUsage
              </InputLabel>
              <Select
                labelId="partial-usage-label"
                id="partial-usage"
                label="Supports PartialUsage"
                name="supportsPartialUsage"
                value={formik.values.supportsPartialUsage}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.supportsPartialUsage &&
                  Boolean(formik.errors.supportsPartialUsage)
                }
              >
                <MenuItem value="true">True</MenuItem>
                <MenuItem value="false">False</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
            sx={FORM_STYLES.actions}
          >
            <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isProcessing}
              {...BUTTON_STYLES.primary}
            >
              {isProcessing ? "Processing..." : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* DOWNLOAD DIALOG */}
      <Dialog
        open={openDownloadDialog}
        onClose={() => setOpenDownloadDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
            width: "420px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          Coupons Created!
        </DialogTitle>

        <DialogContent
          sx={{
            pt: 1,
            pb: 2,
            fontSize: "16px",
            color: "#444",
          }}
        >
          <p style={{ margin: "6px 0" }}>
            <strong>{createdCoupons.length}</strong> coupons have been generated
            successfully.
          </p>

          <p style={{ margin: "6px 0" }}>
            Would you like to download the coupon list now?
          </p>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              paddingX: 3,
              fontWeight: 600,
            }}
            onClick={() => {
              downloadCsv();
              setOpenDownloadDialog(false);
            }}
          >
            Download
          </Button>

          <Button
            variant="outlined"
            color="error"
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              paddingX: 3,
              fontWeight: 600,
            }}
            onClick={() => setOpenDownloadDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CouponModal;
